import { AccountsContext } from 'context/accounts/AccountsContext';
import { FormApi } from 'final-form';
import React, { useContext } from 'react';
import { LocaleContext, NotificationsContext, NotificationTypes } from 'shared';
import { AccountSimple, AddAccountPayload } from 'store/api/types';

import { getErrorMessage } from '../../../utils/getErrorMessage/getErrorMessage';
import { PageWrapper } from '../Dashboard.styles';

import { AddAccountProps } from './AddAccount.types';
import { AddAccountForm } from './addAccountForm/AddAccountForm';

export const AddAccount = ({ history, onAddAccount, onAddSuccess }: AddAccountProps) => {
  const accountsContext = useContext(AccountsContext);
  const localeContext = useContext(LocaleContext);
  const notificationsContext = useContext(NotificationsContext);

  const handleSubmit = async (values: AddAccountPayload, form: FormApi) => {
    try {
      return await onAddAccount(values, form, ({ payload }) => {
        const account = payload as AccountSimple;
        form.reset();

        accountsContext.addAccount({
          name: values.name as string,
          uuid: account.uuid,
        });

        accountsContext.setActiveAccount(account.uuid);

        notificationsContext.showNotification({
          message: localeContext.formatMessage({ id: 'DASHBOARD.ADD-ACCOUNT-SUCCESS' }),
          time: 1000,
          type: NotificationTypes.SUCCESS,
        });

        onAddSuccess(account.uuid);
      });
    } catch (error) {
      notificationsContext.showNotification({
        message: getErrorMessage(error, localeContext),
        time: 1000,
        type: NotificationTypes.ERROR,
      });
    }
  };

  return (
    <PageWrapper className="add-account">
      <AddAccountForm onSubmit={handleSubmit} />
    </PageWrapper>
  );
};
